module.exports = __webpack_public_path__ + "media/images/mission_bg_4-acab6f0fea597610eaba291cce76db9d.svg";